declare global {
    interface Window {
        dataLayer?: Record<string, unknown>[];
    }
}

type AnalyticsEvent = { event: string; [key: string]: unknown };

export const datalayerPush = (event: AnalyticsEvent) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
};

/**
 * Push a newsletter signup event to the data layer.
 *
 * Note: `user_email` is intentionally not included — raw email addresses are
 * PII and would leak to every script reading the data layer (GTM tags, etc.).
 * If a downstream consumer ever needs an identifier, hash the email here.
 */
export const trackNewsletterSignup = (listType: string) => {
    datalayerPush({
        event: "newsletter_signup",
        list_type: listType,
    });
};
